import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../shared";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class RolePricingSchemeLinkService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.APPLET_PREFIX +
      "role-pricing-scheme-links/applet-admin-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.APPLET_PREFIX +
      "role-pricing-scheme-links/applet-admin-ep";
    this.httpClient = http;
  }

  public createRolePricingPermissionLink(
    dtoObject: any,
    appletGuid: string,
    tenantGuid: string,
    rank: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    url =
      this.apiUrl +
      "/?appletGuid=" +
      appletGuid +
      "&tenantGuid=" +
      tenantGuid +
      "&appletLoginSubjectRank=" +
      rank;
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public updateRolePricingPermissionLink(
    dtoObject: any,
    appletGuid: string,
    tenantGuid: string,
    rank: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    url =
      this.apiUrl +
      "/?appletGuid=" +
      appletGuid +
      "&tenantGuid=" +
      tenantGuid +
      "&appletLoginSubjectRank=" +
      rank;
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public deleteRolePricingPermissionLink(
    guid: string,
    appletGuid: string,
    tenantGuid: string,
    rank: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    url =
      this.apiUrl +
      "/" +
      guid +
      "/?appletGuid=" +
      appletGuid +
      "&tenantGuid=" +
      tenantGuid +
      "&appletLoginSubjectRank=" +
      rank;
    return this.httpClient.delete<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getRolePricingPermissionLinkByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    appletGuid: string,
    tenantGuid: string,
    rank: string,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl +
      "/query?" +
      pagination.getQueryKeyValues() +
      "&appletGuid=" +
      appletGuid +
      "&tenantGuid=" +
      tenantGuid +
      "&appletLoginSubjectRank=" +
      rank;

    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getRolePricingPermissionLinkByGuid(
    guid: string,
    visa: ApiVisa,
    appletGuid: string,
    tenantGuid: string,
    rank: string
  ): Observable<BasicApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    url =
      this.apiUrl +
      "/" +
      guid +
      "?appletGuid=" +
      appletGuid +
      "&tenantGuid=" +
      tenantGuid +
      "&appletLoginSubjectRank=" +
      rank;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url + "/" + guid,
      this.getHttpHeader(visa)
    );
  }
}
